/** @type {import('../help-index.js').HelpSidebarItem} */
export const LAB_REC_RECEIPTS_ITEM = {
  id: 'receipts_sidebar',
  screenId: 'lab-rec-receipts',
  label: 'Recibos',
  description: 'Liquidar, cerrar e imprimir recibos de sueldo.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Generás el recibo de sueldo de cada empleado activo para un período y número de liquidación. Podés liquidar uno o todos, revisar el detalle, ajustar importes en borrador, cerrar y después imprimir en PDF.',
      },
      {
        title: 'Antes de liquidar',
        paragraphs: [
          'Tené un período habilitado en Laboral → Salarios → Periodos.',
          'Cargá las novedades del mes en Liquidación → Novedades (días u horas trabajadas y conceptos extras).',
          'Revisá categorías, conceptos y contribuciones patronales si es la primera vez.',
          'Opcional: datos de último depósito de aportes (aparecen en el recibo impreso).',
        ],
      },
      {
        title: 'Paso 1 — Elegir liquidación',
        fields: [
          { label: 'Período', description: 'Período de salarios habilitado (ej. «Enero 2026»).' },
          { label: 'Tipo', description: 'Mensual o SAC (Sueldo Anual Complementario).' },
          { label: 'Nº liq.', description: 'Número de liquidación dentro del período (1 = primera, 2 = segunda quincena, etc.).' },
        ],
        paragraphs: [
          'La lista muestra todos los empleados activos, tengan o no recibo generado.',
        ],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Columnas: Empleado, CUIL, Total rem., Descuentos, Neto, Estado.',
          '«Sin liquidar» — aún no se calculó el recibo.',
          '«Borrador» — liquidado pero editable; «Cerrado» — definitivo, con número de recibo.',
          'Botones por fila: Liquidar e Imprimir (Imprimir solo si está cerrado).',
          'Tocá la fila (fuera de los botones) para ver el detalle del recibo.',
        ],
      },
      {
        title: 'Paso 3 — Acciones masivas',
        bullets: [
          'Liquidar todos — calcula recibos para todos los empleados activos del período.',
          'Cerrar todos — pasa a cerrado los recibos en borrador de esa liquidación y asigna número de recibo.',
          'Imprimir — abre selector de empleados con recibos cerrados y genera PDF.',
        ],
      },
      {
        title: 'Paso 4 — Detalle del recibo',
        intro: 'Al abrir un recibo liquidado ves:',
        bullets: [
          'Datos del empleador y último depósito de aportes (si están cargados).',
          'Haberes remunerativos, no remunerativos y descuentos con cantidad, valor unitario e importe.',
          'Contribuciones patronales por rubro (seguridad social, obra social, ART, etc.).',
          'Gráfico de composición del costo laboral (neto + cargas patronales).',
          'Totales: remunerativo, no remunerativo, descuentos, neto a cobrar.',
        ],
        paragraphs: [
          'En estado Borrador podés editar cantidades e importes de líneas; los descuentos en % se recalculan solos al cambiar haberes remunerativos. Tocá «Guardar cambios» y después «Cerrar recibo».',
          'Un recibo cerrado ya no se edita; solo se imprime.',
        ],
      },
    ],
  },
}
